export const LEGACY_PUBLIC_ASSETS_BASE = 'https://pub-2b435ac1f79c40fbad08ae6c4e4f4143.r2.dev';

function stripTrailingSlashes(value: string): string {
  return value.replace(/\/+$/, '');
}

function stripLeadingSlashes(value: string): string {
  return value.replace(/^\/+/, '');
}

export function publicAssetsBase(): string {
  return stripTrailingSlashes(import.meta.env.VITE_PUBLIC_ASSETS_BASE_URL || LEGACY_PUBLIC_ASSETS_BASE);
}

export function publicAssetUrl(path: string): string {
  return `${publicAssetsBase()}/${stripLeadingSlashes(path)}`;
}
